import { FC } from "react";
import { Chip } from "../Chip";
import styles from "./FilteringOptionsPanel.module.scss";

export type StatusFilterOption = {
    value: string;
    label: string;
};

export type StatusFilterChipsProps = {
    options: StatusFilterOption[];
    /** Currently selected status value(s). Empty / null = none. */
    selected: string | string[] | null;
    onSelect: (value: string | null) => void;
    /** When true, renders an “All” chip that clears selection. Default true. */
    showAll?: boolean;
};

const isSelected = (
    selected: string | string[] | null,
    value: string,
): boolean => {
    if (selected == null) return false;
    if (Array.isArray(selected)) return selected.includes(value);
    return selected === value;
};

const isAllSelected = (selected: string | string[] | null): boolean => {
    if (selected == null) return true;
    if (Array.isArray(selected)) return selected.length === 0;
    return false;
};

/**
 * Status filter chips with optional All + full-width delivery statuses.
 */
export const StatusFilterChips: FC<StatusFilterChipsProps> = ({
    options,
    selected,
    onSelect,
    showAll = true,
}) => (
    <div className={`${styles.grid} ${styles.statusGrid}`}>
        {showAll ? (
            <Chip
                className={styles.chip}
                label="All"
                onClick={() => onSelect(null)}
                selected={isAllSelected(selected)}
                type="button"
            />
        ) : null}
        {options.map(({ value, label }) => (
            <Chip
                className={`${styles.chip} ${
                    value === "DELIVERY_STARTED" ||
                    value === "DELIVERY_FINISHED"
                        ? styles.chipFullWidth
                        : ""
                }`}
                key={value}
                label={label}
                onClick={() =>
                    onSelect(isSelected(selected, value) ? null : value)
                }
                selected={isSelected(selected, value)}
                title={value}
                type="button"
            />
        ))}
    </div>
);

StatusFilterChips.displayName = "StatusFilterChips";
